import { usePageSelector } from 'js/store/hooks';

export const useIsLayoutWithoutHeader = () => {
    const name = usePageSelector((state) => state.pageLayout.name);

    return name === '1-column-without-header';
};
